<template>
  <div class="dash-header-root">
    <div class="header">
      <div class="left-area">
        <div class="dash-header-left" @click="handleBack"></div>
        <div class="ellipsis">
          <b>{{ session.className }}: {{ session.name || 'Unnamed session' }}</b>
        </div>
      </div>
      <!--
    <pre>deadline:{{ session.countdown?.deadline }}</pre>
    <pre>down:{{ session.countdown?.down }}</pre>
    <pre>type:{{ session.countdown?.type }}</pre>
    <pre>studentCtrl:{{ session.countdown?.studentCtrl }}</pre>
    <pre>status:{{ countDownStatus }}</pre>
    -->
      <div class="right-btns">
        <div v-if="session.countdown?.type && countDownStatus != 2" class="countdown flex_c" slot="reference">
          <!--
        <div v-if="countDownStatus > 0" class="flex1">
        </div>
        -->
          <div class="flex1">
            <span>
              <!--
            {{ session.countdown?.type === 1 ? 'Deadline' : 'Countdown' }}
            -->
            </span>
            <span style="padding: 10px"> <i class="el-icon-timer"></i> {{ countdownTime() }} </span>
          </div>
          <!--
          v-if="!(session.countdown?.type === 1 && countDownStatus === 0) && !isStundentPaced"
        -->
          <el-tooltip
            class="item"
            effect="dark"
            v-if="session.sessionType == 'live'"
            :content="session.countdown?.type == 1 ? 'Stop deadline mode' : titles[countDownStatus]"
            placement="bottom">
            <i class="fa" :class="icons[countDownStatus]" @click="countdownBtn" />
          </el-tooltip>
        </div>
        <div class="flex_c" v-if="session.sessionType == 'student' && session.status == 'student' && new Date(session.start) < new Date()">
          <el-tooltip
            class="item"
            effect="dark"
            :content="`${getCountOfExpiredItems()} of roaster ${rooms?.members?.length} students are currently screen-locked.`"
            placement="bottom">
            <div style="padding: 0 10px">{{ getCountOfExpiredItems() }}/{{ rooms.members.length }}</div>
          </el-tooltip>
        </div>
        <div class="flex_c" style="padding-left: 1.5rem" @click="showStudents('teacher')" v-if="coTeacherList.length > 1">
          <el-tooltip v-for="(o, i) in coTeacherList.slice(0, 3)" :key="i" class="item" effect="dark" placement="bottom">
            <div slot="content">{{ o.nickname }}<br />{{ session.uid === o._id ? 'Host' : 'Co-teacher' }}</div>
            <studentAvatar :class="{'-off': !onlineTeachers[o._id]}" :student="o" style="margin-left: -1rem"></studentAvatar>
          </el-tooltip>
          <studentAvatar v-if="coTeacherList.length > 3" :student="{nickname: '+' + (coTeacherList.length - 3)}" style="margin-left: -1rem"></studentAvatar>
          <el-button v-if="!isMeetingOngoing" size="small" class="theme flex_c" @click="handleZoomClick">
            <div class="flex_c">
              <img src="../../assets/meetings.png" class="flex_c" style="height: 1.2rem" />
              <div style="margin-left: 5px">Meeting</div>
            </div>
          </el-button>
        </div>

        <!-- <div v-if="completedGamePayload && isDashboardMode" class="game-analysis-btn" @click="showGameAnalysis = true">GAME ANALYSIS</div> -->
        <div v-if="isDashboardMode" class="game-btn" @click="handleStartGameClick">
          <div class="icon-box">
            <i class="fa fa-gamepad"></i>
          </div>
          <span>START GAME</span>
        </div>
        <div class="invite-button" @click="share" v-if="session">
          Code: <span>{{ session.sid }}</span>
        </div>
        <div class="invite-button" v-if="isDashboard" @click="showStudents('student')">Class Roster {{ getStudentOnLineCount }}/{{ rooms.members.length }}</div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-more" style="font-size: 2.5rem; color: #92b2d1"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <template v-if="!isDashboard">
              <el-dropdown-item command="openDashBoard">Open Dashboard in New Window</el-dropdown-item>
              <el-dropdown-item command="openDevice" :disabled="session.status === 'close'">Open Dashboard in New Device</el-dropdown-item>
            </template>
            <template v-else>
              <el-dropdown-item v-if="!session?.video" command="openProject" :disabled="session.status === 'close'">Open projector in new tab</el-dropdown-item>
              <!--
              :disabled="session.status === 'close' || (session.countdown?.type > 0 && countDownStatus > 0) || session.countdown?.studentCtrl">
            -->
              <el-dropdown-item
                command="turnModel"
                :disabled="
                  session.status === 'close' ||
                  (session.countdown?.type > 0 && countDownStatus > 0) ||
                  (session.countdown?.type == 2 && session.status == 'student' && session.sessionType == 'student')
                ">
                {{ isStundentPaced ? 'Stop' : 'Turn on' }} student-paced
              </el-dropdown-item>
              <el-dropdown-item command="" disabled>Ipad/Phone control</el-dropdown-item>
            </template>
            <template v-if="isOngoing || session.status === 'close'">
              <el-dropdown-item command="reopenClass" divided v-if="session.status === 'close'" :disabled="isMentorOrSubstitute"
                >Reopen session</el-dropdown-item
              >
              <el-dropdown-item command="endLesson" divided v-else-if="!(isBooking && !isOngoing) && !isPblSession">End session</el-dropdown-item>
            </template>
            <el-dropdown-item command="SignOut">Sign out</el-dropdown-item>
            <el-dropdown-item
              command="showTakeaway"
              divided
              v-if="!session.quick && session.status === 'close' && !takeaway?._id && (session.students?.length || session.regNum)"
              >Generate takeaway</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- End .header -->

    <!-- MODALS AREA -->
    <el-dialog
      v-if="session.countdown?.type > 0 && !loading"
      class="flex_c"
      title="Reminder"
      :visible.sync="showCountDown"
      width="600px"
      :before-close="countDownClose"
      :append-to-body="true"
      :close-on-click-modal="isStoped"
      :show-close="isStoped">
      <div v-if="session.countdown?.type === 2" class="countdownDialog">
        <div v-if="countDownStatus === 0">
          Would like to start counting down and turn to student-pace mode?
          <!--
          Please notice that it will turn to teacher-mode after
          <el-select v-model="countdownVal" placeholder="select" style="width: 3.5rem; margin: 0 0.5rem">
            <el-option v-for="o in countdownOptions" :key="o" :label="o" :value="o"></el-option>
          </el-select>
          minute completes.
          -->
        </div>
        <div v-else>
          {{ confirms[countDownStatus] }}
        </div>
      </div>
      <div v-else-if="session.countdown?.type === 1">
        <div v-if="countDownStatus === 2">Deadline mode has ended</div>
        <div v-else-if="countDownStatus === 1">Confirm stop deadline mode?</div>
      </div>
      <div style="height: 1rem"></div>
      <div class="flex_r">
        <span slot="footer" class="dialog-footer">
          <el-button v-show="isStoped" @click="countDownClose">Cancel</el-button>
          <el-button :type="types[countDownStatus]" @click="countdownFn(1)">{{ btnStr[countDownStatus] }}</el-button>
          <!-- <el-button v-show="countDownStatus === 1" type="danger" @click="countdownFn(2)">{{'Stop and End Session'}}</el-button> -->
        </span>
      </div>
    </el-dialog>
    <el-dialog title="Confirm" :visible.sync="showBackConfirm" :append-to-body="true">
      <div class="pd_t1">Class is still in progress, are you sure you want to leave?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBackConfirm = false">Cancel</el-button>
        <el-button @click="endClassroom()" v-if="!(isBooking && !isOngoing)">End the class</el-button>
        <el-button type="primary" @click="backtToClass">Leave without ending the class</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Ending Session" :visible.sync="dialogVisible" :append-to-body="true">
      <div class="dialog_page">
        <div v-if="isStundentPaced">Your session is currently in Student-Paced Mode. Are you sure you want to end your session?</div>
        <div class="flex_r pd_t1" v-if="isStundentPaced">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="danger" @click="endClassroom()">Yes,I'm sure!</el-button>
        </div>
        <div class="flex_r pd_t1" v-else>
          <el-button @click="cancelEndClass()">Cancel</el-button>
          <el-button type="danger" class="confirmBtn" @click="endClassroom()">End Session</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="!session.quick" title="" :visible.sync="takeawayVisible" :append-to-body="true">
      <div class="dialog_page">
        <div>
          Would you like to generate the takeaways of this session for students? Please notice that once takeaways are generated, students' answers will remain
          consistent with the time of generation and will not be updated further.
        </div>
        <div class="flex_r pd_t1">
          <el-button type="primary" @click="generateTakeaway">Generate now</el-button>
          <el-button @click="hideTakeaway">Not this time</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="newDevice" center :append-to-body="true" :show-close="false" class="flex_c new_device">
      <div class="flex_v flex_l" style="color: #fff">
        <h6 class="pd_1">To Open the Teacher Dashboard on a Second Device:</h6>
        <p>1. Open a web browser on a separate computer or tablet</p>
        <p class="pd_t1">
          2. Go to <a :href="`${dashUrl}`" target="_blank" class="theme">{{ dashUrl }}</a>
        </p>
        <div class="flex_c pd_1">
          <el-button type="primary" round @click="newDevice = false">Got lt!</el-button>
        </div>
      </div>
    </el-dialog>

    <GameSettingPannel v-if="showGameModal" :resumeGameId="resumeGameOnId" @close="showGameModal = false" @start="handleStartGame" @end-game="handleEndGame" />

    <TeamPreviewModal v-if="showTeamPreview" @close="showTeamPreview = false" @start="handleStartZoomGameOn" @save-teams="handleSaveTeamsFromPreview" />
    <!-- GAME RELATED MODALS -->
    <div class="dash-game-modals">
      <div v-if="showGameAnalysis" key="game-analysis">
        <GameAnalyticsModal
          :slides="completedGamePayload ? completedGamePayload.slides : []"
          :responses="completedGamePayload ? completedGamePayload.responses : []"
          :analysis="completedGamePayload ? completedGamePayload.analysis : null"
          @close="showGameAnalysis = false"
          @open-slide="openSlideAnalytics" />
      </div>

      <div v-if="showSlideAnalytics" key="slide-analytics">
        <SlideAnalyticsModal
          :slide="activeSlide"
          :responses="
            completedGamePayload
              ? completedGamePayload.responses.filter(
                  (r) =>
                    (activeSlide && r.page === activeSlide.page) || r.page === activeSlide.id || r.page_id === activeSlide.id || r.quizId === activeSlide.id
                )
              : []
          "
          :analysis="completedGamePayload ? completedGamePayload.analysis : null"
          @close="showSlideAnalytics = false"
          @close-all="handleCloseAllAnalytics"
          @open-cpa-demo="openCpaDemo" />
      </div>

      <div v-if="showCpaDemo" key="cpa-demo">
        <!-- DEMO REPLAY PAGE -->
        <DemoReplayPage :curQuestion="selectedCpaDemoSlide" :roomId="session.sid" @close="closeCpaDemo" />
      </div>

      <!-- REMOTE SYNCED GAME TRACKING (Primarily for Projector) -->
      <div v-if="showRemoteGameTracking && isProjectorMode" key="remote-game-tracking">
        <GameTrackingPage
          :gameConfig="remoteGamePayload.gameConfig"
          :teams="remoteGamePayload.teams"
          :isDashboard="false"
          @end-game="closeRemoteGameTracking" />
      </div>
    </div>
  </div>
</template>
<script>
import StudentAvatar from '../common/studentAvatar'
import {showLoading, hideLoading} from '@/utils/loading'
import {mapActions, mapState, mapGetters} from 'vuex'
import GameSettingPannel from './Game/GameSettingPannel.vue'
import GameAnalyticsModal from './Game/GameAnalyticsModal.vue'
import SlideAnalyticsModal from './Game/SlideAnalyticsModal.vue'

import TeamPreviewModal from './Game/TeamPreviewModal.vue'
import DemoReplayPage from './Game/DemoReplayPage.vue'
import GameTrackingPage from './Game/GameTrackingPage.vue'
export default {
  components: {
    StudentAvatar,
    GameSettingPannel,
    GameAnalyticsModal,
    SlideAnalyticsModal,
    TeamPreviewModal,
    DemoReplayPage,
    GameTrackingPage,
  },
  props: {
    openEvaluate: {type: Function},
    share: {type: Function, default: null},
    showStudents: {type: Function},
    reopenClass: {type: Function},
    turnModel: {type: Function},
    confirmModeChange: {type: Function},
  },
  data() {
    return {
      now: Date.now(),
      nowInterval: null,
      isLocalMeetingActive: false,
      isLocalMeetingStoppedRecently: false,
      showZoomSelection: false,
      showGameModal: false,
      resumeGameOnId: null,
      showTeamPreview: false,
      completedGamePayload: null,
      showGameAnalysis: false,
      showSlideAnalytics: false,
      activeSlide: null,
      newDevice: false,
      showCpaDemo: false,
      selectedCpaDemoSlide: null,
      showRemoteGameTracking: false,
      remoteGamePayload: null,
      dashUrl: `${hostUrl}/v2/dash`,
      isDashboard: this.$route.name === 'd',
      isOngoing: false,
      dialogVisible: false,
      takeawayVisible: false,
      leaving: false,
      drawer: false,
      loading: false,
      countDownStatus: 0,
      icons: ['fa-play-circle', 'fa-stop-circle', 'fa-stop-circle-o'],
      confirms: ['', 'Confirm stop countdown mode?', 'Countdown mode has ended.'],
      titles: [],
      types: ['primary', 'danger', 'warning'],
      btnStr: ['Start', 'End and evaluate', 'End session and evaluate'],
      countdownOptions: [15, 30, 45, 60, 70],
      countdownVal: '',
      showCountDown: false,
      showBackConfirm: false,
      countdownList: null,
      back: null,
      isGameOnChoice: false,
    }
  },

  watch: {
    session: {
      async handler(val) {
        if (val.countdown?.down) this.countdownVal = val.countdown.down
      },
      deep: true,
    },
    'session.demoReplay': {
      handler(val) {
        if (this.isProjectorMode) {
          if (val) {
            console.log('Syncing Demo Replay (Remote):', val)
            this.selectedCpaDemoSlide = val
            this.showCpaDemo = true
          } else {
            this.showCpaDemo = false
            this.selectedCpaDemoSlide = null
          }
        }
      },
      immediate: true,
    },
    'session.gameOnTracking': {
      handler(val) {
        if (val) {
          console.log('Syncing Game Tracking (Remote):', val)
          this.remoteGamePayload = val
          this.showRemoteGameTracking = true
        } else if (val === null) {
          this.showRemoteGameTracking = false
          this.remoteGamePayload = null
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('student', ['currentPageIndex']),
    ...mapState(['session', 'countDown', 'user', 'takeaway', 'meeting']),
    ...mapState('teacher', ['teachers', 'rooms', 'onlineTeachers', 'isLiveDemoRecording']),
    ...mapGetters(['isMentorOrSubstitute', 'getPageById']),
    isMeetingOngoing() {
      if (this.isLocalMeetingActive) return true
      if (this.isLocalMeetingStoppedRecently) return false

      if (!this.session?.lastMeetingHeartbeat) return false
      return this.now - this.session.lastMeetingHeartbeat < 30000
    },
    ...mapGetters('teacher', ['questions']),
    coTeacherList() {
      const list = this.teachers.filter((v) => v._id !== this.session.uid)
      const host = this.teachers.find((v) => v._id === this.session.uid)
      if (host) list.unshift(host)
      return list
    },
    getStudentOnLineCount() {
      return this.$store.getters['teacher/onlineStudentCount']
    },
    isStundentPaced() {
      return this.session.status === 'student'
    },
    isStoped() {
      return this.countDownStatus !== 2
    },
    isBooking() {
      return this.session?.type?.indexOf('booking') != -1
    },
    isPblSession() {
      return this.session?.type?.indexOf('pdSchoolPbl') != -1
    },
    isModalActive() {
      return this.showSlideAnalytics || this.showCpaDemo || this.showGameAnalysis || this.showGameModal || this.showTeamPreview
    },
    isDashboardMode() {
      const path = (this.$route && this.$route.path) || window.location.pathname
      return path.includes('/d/')
    },
    isProjectorMode() {
      const path = (this.$route && this.$route.path) || window.location.pathname
      return path.includes('/t/')
    },
    isVideoType() {
      return this.session.sessionType === 'videoSession' || this.session.task?.mode === 'video'
    },
  },
  created() {
    window._ttt = this
    if (isDev) this.countdownOptions.unshift('0.2')
    this.back = this.$route.query.back
  },
  mounted() {
    if (this.user && this.user._id) {
      this.checkGameOnRestore()
      this.checkCompletedGameAnalytics()
    } else {
      const unwatch = this.$watch('user', (val) => {
        if (val && val._id) {
          this.checkGameOnRestore()
          this.checkCompletedGameAnalytics()
          unwatch()
        }
      })
    }

    this.titles.push('Start countdown mode', 'Stop countdown mode', 'Close countdown mode')
    this.countdownVal = this.countDown.time ?? this.session.countdown?.down
    if (window.countDownIt) clearInterval(window.countDownIt)
    window.countDownIt = setInterval(() => {
      //this.countDownStatus = this.countDown.end === null ? 0 : Date.now() > this.countDown.end ? 2 : 1
      this.countDownStatus = this.session.countdown?.deadline == null ? 0 : Date.now() > new Date(this.session.countdown.deadline).getTime() ? 2 : 1
      if (this.countDown.status !== this.countDownStatus) {
        this.setCountDown({status: this.countDownStatus})
      }
      if (this.countDownStatus === 2) {
        this.showCountDown = true
      }
      if (this.session.status == 'close') {
        this.showCountDown = false
      }
      if (this.session.status == 'student' && this.session.sessionType == 'student' && !this.countdownList) {
        this.getCountdownList()
      }
      this.isOngoing = new Date() > new Date(this.session.start)
      this.isGameOnChoice = this.session.gameOn?.zoomChoice === 'game-on'
      this.$forceUpdate()
    }, 1000)

    EventBus.$on('triggerZoomGameOn', () => {
      this.handleZoomChoice('game-on')
    })

    this.nowInterval = setInterval(() => {
      this.now = Date.now()
      this.updateLocalState()
    }, 1000)
    window.addEventListener('storage', this.onStorageChange)
    this.updateLocalState()
  },
  beforeDestroy() {
    if (window.countDownIt) clearInterval(window.countDownIt)
    EventBus.$off('zoomGameOn')
    EventBus.$off('triggerZoomGameOn')
    if (this.nowInterval) {
      clearInterval(this.nowInterval)
    }
    window.removeEventListener('storage', this.onStorageChange)
  },
  methods: {
    ...mapActions(['setCountDown']),
    getNormalizedPageId(page) {
      if (!page) return null
      return page.includes('::') ? page.split('::')[1] : page
    },
    async checkCompletedGameAnalytics() {
      const doRestore = async () => {
        try {
          if (!window.App || !this.session || !this.session._id) return

          // Find games for this session, sorted by expiresAt descending
          const rs = await App.service('game-on').find({
            query: {
              sessionId: this.session._id,
              $limit: 10,
              $sort: {expiresAt: -1},
            },
          })
          const records = Array.isArray(rs) ? rs : rs.data ? rs.data : []

          const record = records.find((r) => r.status === 2 || (r.status === 1 && r.expiresAt && new Date(r.expiresAt) < new Date()))

          if (!record || !record.analysis) return

          const slides = []
          if (record.pageIds && this.questions) {
            record.pageIds.forEach((pageId, index) => {
              const normalizedPageId = this.getNormalizedPageId(pageId)

              const pageQuestions = this.questions.filter((x) => {
                if (x.id.includes('::')) return x.id.split('::')[1] === normalizedPageId
                return this.getNormalizedPageId(x.page) === normalizedPageId
              })

              console.log('asdljljkasd', pageQuestions)
              if (!pageQuestions.length) return

              const pageData = this.getPageById(pageId)

              const serial = index + 1

              const formattedQuestions = pageQuestions.map((q, qIndex) => ({
                ...q,
                id: q._id || q.id,
                slideSerial: serial,
                questionSerial: qIndex + 1,
              }))

              const q = formattedQuestions[0]

              let titleType = ''
              if (pageData?.type === 'video') {
                titleType = 'VIDEO'
              } else {
                titleType = q.type ? q.type.toUpperCase() : 'TEXT'
                if (q.type === 'choice') titleType = 'MULTIPLE CHOICE'
              }

              slides.push({
                pageId: normalizedPageId,
                serial,
                pic: pageData?.pic || '',

                title: `${titleType} QUESTION`,
                points: q.score?.points ?? (q.type === 'choice' && (q.options || []).some((o) => o.on) ? 2 : null),

                questions: formattedQuestions,
                _displayIdx: String(serial).padStart(2, '0'),
                correctPercent: 0,
                totalResponses: 0,
                difficulty: 'NO DATA',
              })
            })
          }
          this.completedGamePayload = {
            slides: slides,
            responses: record.responses || [],
            analysis: record.analysis || null,
          }
        } catch (err) {
          console.error('Failed to check completed game analytics:', err)
        }
      }

      if (this.questions && this.questions.length > 0) {
        doRestore()
      } else {
        const unwatch = this.$watch('questions', (val) => {
          if (val && val.length > 0) {
            doRestore()
            unwatch()
          }
        })
      }
    },
    async checkGameOnRestore() {
      // Always query by sessionId + status:1 (ignore gameOnId URL param)
      const doRestore = async () => {
        try {
          if (!window.App) return

          // Find any active or recently ended game for this session
          const rs = await App.service('game-on').find({
            query: {
              sessionId: this.session._id,
              status: {$in: [1, 2]},
              $limit: 1,
              $sort: {createdAt: -1},
            },
          })
          const record = Array.isArray(rs) ? rs[0] : rs.data ? rs.data[0] : null

          if (!record) return

          // Skip if the game has already expired, unless it's in analysis mode/ended
          if (record.status === 1 && record.expiresAt && new Date(record.expiresAt) < new Date()) {
            console.log('Game-On record found but already expired, skipping restore.')
            return
          }

          // Skip if the game is ended and the teacher left the game mode
          if (record.status === 2 && record.leftGameMode) {
            console.log('Game-On record is ended and left, skipping restore.')
            return
          }

          // Reconstruct slides from pageIds
          const slides = []
          if (record.pageIds && this.questions) {
            record.pageIds.forEach((pageId) => {
              const q = this.questions.find((x) => x.page === pageId)
              if (q) {
                const pageData = this.getPageById(q.page)
                let titleType = q.type ? q.type.toUpperCase() : 'TEXT'
                if (q.type === 'choice') titleType = 'MULTIPLE CHOICE'

                slides.push({
                  ...q,
                  id: q._id || q.id,
                  pic: q.pic || pageData?.pic || '',
                  title: titleType + ' QUESTION',
                  points: q.score?.points ?? 2,
                })
              }
            })
          }

          const gameConfig = {
            slides,
            slideIds: record.pageIds,
            timing: record.timePerQuestion || 300,
            time: record.timePerQuestion || 300,
            gameOnRecord: record,
          }

          // Reconstruct activeTeams
          const dbTeams = record.teams || []
          const dbMembers = record.members || []
          const classMembers = (this.rooms && this.rooms.members) || []
          const coreColors = ['#FF3366', '#FF9933', '#FFCC00', '#33CC33', '#3399FF', '#9933FF']

          const teams = dbTeams.map((t, idx) => {
            const teamMembers = dbMembers
              .filter((m) => m.teamId === t.id)
              .map((m) => {
                const user = classMembers.find((c) => c._id === m.uid) || {}
                return {
                  id: m.uid,
                  name: m.name || user.nickname || user.name || 'Unknown User',
                  avatar: m.avatar || user.avatar || user.pic || '',
                  score: m.score || 0,
                  originalMemberData: m,
                }
              })
            return {
              id: t.id,
              name: t.name || `TEAM ${t.id}`,
              score: t.score || 0,
              progress: t.progress || 0,
              color: coreColors[idx % coreColors.length],
              members: teamMembers,
            }
          })

          // Active game: restore tracking UI
          if (this.isProjectorMode) {
            this.remoteGamePayload = {gameConfig, teams}
            this.showRemoteGameTracking = true
          } else {
            this.resumeGameOnId = record._id
            this.showGameModal = true
          }
        } catch (err) {
          console.error('Failed to restore Game-On state:', err)
        }
      }

      // In projector mode, try immediately (questions may not be loaded yet)
      if (this.isProjectorMode) {
        doRestore()
      } else if (this.questions && this.questions.length > 0) {
        doRestore()
      } else {
        const unwatch = this.$watch('questions', (val) => {
          if (val && val.length > 0) {
            doRestore()
            unwatch()
          }
        })
      }
    },
    handleCommand(cmd) {
      if (this[cmd]) this[cmd]()
    },
    handleCloseAllAnalytics() {
      this.showSlideAnalytics = false
      this.showGameAnalysis = false
    },
    openSlideAnalytics(slide) {
      this.activeSlide = slide
      this.showSlideAnalytics = true
    },
    async handleZoomClick() {
      if (this.session.sid) {
        localStorage.setItem('meeting_active_' + this.session.sid, 'true')
        localStorage.removeItem('meeting_stopped_at_' + this.session.sid)
      }
      await this.$store.dispatch('upSession', {lastMeetingHeartbeat: Date.now()})
      if (this.isVideoType) {
        this.toZoom('normal')
        return
      }
      if (this.session.gameOn) {
        this.toZoom('game-on', true)
      } else {
        this.handleZoomChoice('game-on', true)
      }
    },
    toZoom(choice, isAudioMuted = false) {
      if (this.isShowStudentName) {
        this.showStudentName(this.currentVideoQuizId)
      }
      const userName = this.user?.nickname || this.user?.name || ''
      const audioMuted = (choice === 'autoCountdown' || isAudioMuted) ? '&audioMuted=true&videoMuted=true' : ''
      const url = location.origin + '/livekit?name=' + encodeURIComponent(userName) + '&sid=' + this.session.sid + '&session_id=' + this.session._id + audioMuted
      window.open(url, '_blank')
      const zoomChoice = choice || this.session.gameOn?.zoomChoice
      if (zoomChoice === 'game-on') {
        const recordId = this.session.gameOn?.gameOnRecordId || this.session.gameOn?.teamGameId
        if (recordId) {
          this.handleStartZoomGameOn({recordId})
        } else {
          this.showTeamPreview = true
        }
      }
    },
    async handleStartGameClick() {
      if (!this.isMeetingOngoing) {
        await this.handleZoomClick()
      }
      if (this.session.gameOn || this.resumeGameOnId) {
        this.showGameModal = true
      } else {
        this.showTeamPreview = true
      }
    },
    async handleZoomChoice(choice, isAudioMuted = false) {
      await this.$store.dispatch('upSession', {
        gameOn: {
          ...(this.session.gameOn || {}),
          zoomChoice: choice,
        },
      })
      this.showZoomSelection = false
      this.toZoom(choice, isAudioMuted)
    },
    leavePage() {
      if (!history.state.back) return window.close()
      else if (history.state.back) return history.back()
      if (this.session._id) {
        window.location.href = `${hostUrl}/v2/my/content`
      }
    },
    async getCountdownList() {
      this.countdownList = await App.service('rooms').get('countdownList', {query: {sid: this.session.sid}})
    },
    getCountOfExpiredItems(list) {
      let count = 0
      if (this.countdownList) {
        const currentTime = Date.now()

        Object.entries(this.countdownList).forEach(([key, value]) => {
          const itemTime = new Date(value).getTime() + this.session.countdown.down * 60 * 1000
          if (itemTime < currentTime) {
            count++
          }
        })
      }
      return count
    },
    endLesson() {
      this.dialogVisible = true
      console.log(this.dialogVisible)
    },
    cancelEndClass() {
      this.dialogVisible = false
    },
    async endClassroom(noJump) {
      //结束课程
      showLoading()
      this.dialogVisible = false
      this.setCountDown({status: 0})
      await this.$store.dispatch('upSession', {countdown: {type: 0, down: null, deadline: null, studentCtrl: false}, status: 'close'})
      hideLoading()
      if (!this.takeaway?._id && (this.session?.students?.length || this.session?.regNum)) {
        this.takeawayVisible = true
        this.leaving = true
      } else if (!noJump) {
        this.backtToClass()
      }
      //this.leavePage()
      if (this.session.quick) {
        window.location.href = `${hostUrl}/v2/detail/session/${this.session._id}`
      }
    },
    showTakeaway() {
      this.takeawayVisible = true
    },
    hideTakeaway() {
      this.takeawayVisible = false
      if (this.leaving) {
        this.backtToClass()
      }
    },
    async generateTakeaway(noJump) {
      try {
        await App.service('session-snapshot').get('snapshot', {
          query: {_id: this.session._id},
        })
      } catch (e) {}
      setTimeout(() => {
        window.location.href = `${hostUrl}/v2/account/takeaway/${this.session._id}`
      }, 100)
    },
    openDevice() {
      this.newDevice = true
    },
    openProject() {
      const url = `${location.origin}/t/${this.session.sid}`
      var strWindowFeatures = 'width=1200,height=750,menubar=yes,location=yes,resizable=yes,scrollbars=true,status=true,top=100,left=200'
      window.open(url, 'project', strWindowFeatures)
    },
    openDashBoard() {
      const url = `${location.origin}/d/${this.session.sid}`
      var strWindowFeatures = 'width=960,height=640,menubar=yes,resizable=yes,scrollbars=true,status=true,top=100,left=200'
      window.open(url, 'dashboard', strWindowFeatures)
    },
    async countdownBtn() {
      if (this.session.status === 'close') {
        if (!this.isMentorOrSubstitute) {
          this.$message.info('Please reopen session first')
        }
        return
      }
      if (!this.showCountDown) {
        this.showCountDown = true
      }
    },
    countdownTime() {
      if (this.countDownStatus != 1) return `${this.session.countdown.down} mins`
      //const ex = parseInt((this.countDown.end - new Date().getTime()) / 1000)
      const ex = parseInt((new Date(this.session.countdown.deadline).getTime() - new Date().getTime()) / 1000)
      const srr = []
      const h = parseInt((ex % 86400) / 3600)
      const m = parseInt((ex % 3600) / 60)
      const s = parseInt(ex % 60)
      srr.push(h < 10 ? '0' + h : h, m < 10 ? '0' + m : m, s < 10 ? '0' + s : s)
      //if (ex > 24 * 3600) {
      // return new Date(this.session.countdown.deadline).toLocaleString()
      // }
      return (ex > 86400 ? parseInt(ex / 86400) + ' Day ' : '') + srr.join(':')
      /*
      let sec = ex % 60
      let min = parseInt(ex / 60)
      if (min <= 0 && sec < 0) return '00:00'
      if (min < 10) min = '0' + min
      if (sec < 10) sec = '0' + sec
      return `${min}:${sec}`
      */
    },
    async countdownFn(f) {
      if (this.loading) return
      this.loading = true
      if (this.countDownStatus > 0) {
        this.countDownClose()
        await this.endClassroom(1)
        this.openEvaluate()
        await this.setCountDown({time: this.countdownVal, status: 0})
        this.loading = false
        return console.log('close countDown mode', this.countDown.end)
      }
      // open to student-paced
      if (!this.isStundentPaced) {
        this.$store.dispatch('upSession', {status: 'student'})
      }
      this.setCountDown({time: this.countdownVal, status: 1})

      const data = {...this.session.countdown, ...{deadline: new Date(new Date().getTime() + this.session.countdown?.down * 60 * 1000)}}
      //console.log(this.session.countdown, data, '<=============countdownBtn')
      await this.$store.dispatch('upSession', {countdown: data})

      this.countDownClose()
      console.log('start countDown mode', this.countdownVal, this.countDown.end)
      this.loading = false
    },
    countDownClose() {
      this.showCountDown = false
    },
    handleBack() {
      if (this.isLiveDemoRecording) {
        this.$message && this.$message.warning("Your Live Demo is still in progress. Please click 'End Demo' before returning to the classroom.")
        return
      }
      if (this.session.status == 'close' || !this.isOngoing) {
        this.backtToClass()
      } else {
        this.showBackConfirm = true
      }
    },
    async SignOut() {
      await App.authentication.removeAccessToken()
      window.location.href = hostUrl
    },
    async backtToClass() {
      // await this.$store.dispatch('upSession', {status: 'student'})
      let {back} = this.$route.query
      if (back) {
        setTimeout(() => {
          if (back.indexOf('://')) return (window.location.href = back)
          if (back.substring(0, 4) !== '/v2/') back = '/v2' + back
          window.location.href = `${hostUrl}${back}`
        }, 1)
      } else {
        try {
          window.close()
        } catch (e) {
          console.log(e, '<=================')
        }
        setTimeout(() => {
          window.location.href = `${hostUrl}/v2/home/index`
        }, 100)
      }
    },
    handleStartGame(payload) {
      console.log('Game Started:', payload)
      this.showGameModal = false
    },
    async handleStartZoomGameOn(payload) {
      console.log('Zoom Game-On Started:', payload)
      this.showTeamPreview = false

      showLoading()
      try {
        const result = await App.service('session').patch('gameOn', {
          _id: this.session._id,
          gameOnRecordId: payload.recordId,
        })
      } catch (e) {
        console.error(e)
        this.$message.error('Failed to start Zoom with Game-on')
      }
      hideLoading()
    },
    handleSaveTeamsFromPreview() {
      this.showTeamPreview = false
      this.$nextTick(() => {
        this.showGameModal = true
      })
    },
    handleEndGame(payload) {
      // Store the completed game payload so GAME ANALYSIS button appears
      if (payload) this.completedGamePayload = payload
      this.showGameModal = false
    },
    async openCpaDemo(slide) {
      console.log('Opening CPA Demo from Header:', slide)

      // Close analytics first
      this.showSlideAnalytics = false

      // Give Vue a tick to remove the previous modal's DOM
      this.$nextTick(async () => {
        // Enrich slide with full question data if available in completedGamePayload
        let enrichedSlide = {...slide}
        if (this.completedGamePayload && this.completedGamePayload.slides) {
          const fullQuestion = this.completedGamePayload.slides.find((q) => q.page === (slide.page || slide.id) || q.id === (slide.page || slide.id))
          if (fullQuestion) {
            enrichedSlide = {...slide, ...fullQuestion}
          }
        }

        this.selectedCpaDemoSlide = enrichedSlide
        this.showCpaDemo = true

        // Sync to session for projector view
        if (this.isDashboardMode) {
          try {
            await this.$store.dispatch('upSession', {demoReplay: enrichedSlide})
          } catch (e) {
            console.error('Failed to sync demoReplay to session:', e)
          }

          // Patch isDemoOn: true to DB
          // const recordId = enrichedSlide.gameOnRecord?._id ||
          //                  (this.remoteGamePayload?.gameConfig?.gameOnRecord?._id) ||
          //                  (this.session.gameOnTracking?.gameConfig?.gameOnRecord?._id)
          // if (recordId && window.App) {
          //   App.service('game-on').patch(recordId, {isDemoOn: true}).catch(err => console.error('Failed to patch isDemoOn:true', err))
          // }
        }
      })
    },
    async closeCpaDemo() {
      this.showCpaDemo = false
      this.selectedCpaDemoSlide = null

      // Clear from session
      try {
        await this.$store.dispatch('upSession', {demoReplay: null})
      } catch (e) {
        console.error('Failed to clear demoReplay from session:', e)
      }

      // Patch isDemoOn: false to DB
      const recordId =
        this.selectedCpaDemoSlide?.gameOnRecord?._id ||
        this.remoteGamePayload?.gameConfig?.gameOnRecord?._id ||
        this.session.gameOnTracking?.gameConfig?.gameOnRecord?._id
      if (recordId && window.App) {
        App.service('game-on')
          .patch(recordId, {isDemoOn: false})
          .catch((err) => console.error('Failed to patch isDemoOn:false', err))
      }
    },
    async closeRemoteGameTracking() {
      this.showRemoteGameTracking = false
      this.remoteGamePayload = null

      // Always clear from session so other devices sync
      try {
        await this.$store.dispatch('upSession', {gameOnTracking: null})
      } catch (e) {
        console.error('Failed to clear gameOnTracking from session:', e)
      }
    },
    onStorageChange(e) {
      if (e.key === 'meeting_active_' + this.session.sid || e.key === 'meeting_stopped_at_' + this.session.sid) {
        this.updateLocalState()
      }
    },
    updateLocalState() {
      this.isLocalMeetingActive = localStorage.getItem('meeting_active_' + this.session.sid) === 'true'
      const stoppedAt = Number(localStorage.getItem('meeting_stopped_at_' + this.session.sid))
      this.isLocalMeetingStoppedRecently = !!(stoppedAt && Date.now() - stoppedAt < 60000)

      // Self-healing: if localStorage says meeting is active but the server heartbeat
      // has expired (no update for 30+ seconds) or was never set, clear the stale flag
      if (this.isLocalMeetingActive) {
        if (!this.session?.lastMeetingHeartbeat) {
          // No heartbeat at all — meeting is definitely not active
          localStorage.removeItem('meeting_active_' + this.session.sid)
          this.isLocalMeetingActive = false
        } else {
          const elapsed = this.now - this.session.lastMeetingHeartbeat
          if (elapsed >= 30000) {
            console.log('[Meeting] Clearing stale meeting_active localStorage flag (heartbeat expired)')
            localStorage.removeItem('meeting_active_' + this.session.sid)
            this.isLocalMeetingActive = false
          }
        }
      }
    },
  },
}
</script>
<style>
.new_device {
  background: #333333dd;
}
.new_device .el-dialog {
  background: transparent;
}
.countdown {
  background-color: aliceblue;
  border-radius: 2.2rem;
  overflow: hidden;
  padding: 0.1rem 0.2rem;
}
.countdown > div:last-child {
  padding: 0 0.5rem;
  font-size: 1.2rem;
}
.countdown i {
  font-size: 2.2rem;
  color: #15c39a;
  position: relative;
}
.countdown i.fa-play-circle {
  color: #15c39a;
  cursor: pointer;
}
.countdown i.fa-stop-circle-o {
  color: darkorange;
  cursor: pointer;
}
.countdownDialog .el-input__inner {
  padding: 0 0.5rem;
  text-align: center;
}
.countdown i.el-icon-timer {
  font-size: 1rem;
}
.countdown i.fa-stop-circle {
  color: crimson;
  cursor: pointer;
  animation: breath 0.6s linear 0.5s infinite alternate;
}
@keyframes breath {
  0% {
    text-shadow: 0 0 0.2rem red;
  }
  100% {
    text-shadow: 0 0 0rem red;
  }
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.game-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  height: 42px;
  padding: 0 20px;
  border-radius: 8px;
  box-sizing: border-box;

  background: #6c5ce7;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 2px #fde047;

  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;

  cursor: pointer;
  transition: all 0.3s ease;
}

/* Icon box */
.icon-box {
  background-color: rgba(255, 255, 255, 0.25);
  padding: 6px;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hover effect */
.game-btn:hover {
  box-shadow: 0 0 0 2px #facc15, 0 6px 16px rgba(108, 92, 231, 0.4);
  transform: translateY(-2px);
}

/* GAME ANALYSIS button */
.game-analysis-btn {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  height: 40px;
  padding: 0 18px;
  border-radius: 8px;
  background: #ff00aa;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  transition: 0.3s ease;
  box-shadow: 0 0 10px rgba(255, 0, 170, 0.4);
}
.game-analysis-btn:hover {
  background: #e6009a;
  box-shadow: 0 0 18px rgba(255, 0, 170, 0.7);
  transform: scale(1.03);
}
</style>
